<template>
  <v-form v-model="valid">
    <v-card-text class="px-0 pb-0">
      <v-select
        v-if="displaySmsDids"
        style="z-index: 999;"
        v-model="param.did_id"
        :items="smsDidsNumber"
        :label="$t('chat.smsToEmails.phoneNumber')"
        prepend-icon="mdi-sort-numeric-variant"
        item-value="id"
        item-text="display"
        :rules="[phoneNumberIsRequired]"
        @change="onDidChange"
        chips
      >
        <template v-slot:selection="{ item }">
          <v-chip>
            <span>{{ item.display }}</span>
          </v-chip>
        </template>
        <template v-slot:item="{ item }">
          {{ item.display }}
        </template>
      </v-select>
      <div v-if="param.did_id !== null">
        <v-switch
          :label="$t('chat.smsToEmails.enabled')"
          v-model="param.enabled"
        />
        <div v-for="(line, linePosition) in emails" v-bind:key="linePosition">
          <v-row>
            <v-col cols="12" sm="9">
            <v-text-field
              v-model="line.email"
              prepend-icon="mdi-email"
              data-testid="sms-email"
              :label="$t('chat.smsToEmails.email')"
              :rules="[emailIsRequired, emailIsValid]"
              placeholder=''
            ></v-text-field>
            </v-col>
            <v-col cols="12" sm="1" class="mt-4 mr-2">
            <v-btn
              text
              color="red"
              icon
              :disabled="disableDelete(line, linePosition)"
              @click="deleteLine(linePosition)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            </v-col>
            <v-col cols="12" md="1" class="mt-4">
            <v-btn
              text
              color="primary"
              icon
              @click="addLine()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="px-0 pb-0">
      <v-btn text @click="reset()" :loading="loadingReset">{{ $t('chat.smsToEmails.reset') }}</v-btn>
      <v-btn text @click="submit()" :disabled="!valid" :loading="loadingSave" color="primary">{{ $t('chat.smsToEmails.save') }}</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-sms-to-email',
  data () {
    return {
      valid: false,
      loadingReset: false,
      loadingSave: false,
      param: {
        did_id: null,
        emails: null,
        enabled: null
      },
      emails: []
    }
  },
  created () {
    this.get()
  },
  computed: {
    ...mapGetters({
      currentUser: 'chat/authenticatedRocketChatUser',
      smsToEmails: 'chat/SmsToEmails/smsToEmails',
      smsDids: 'chat/smsDids'
    }),

    smsDidsNumber: function () {
      const dids = []
      this.smsDids.forEach(did => {
        dids.push({
          display: did.formatted_did,
          id: did.id
        })
      })
      return dids
    },

    displaySmsDids () {
      return this.currentUser !== null && this.currentUser.smsCapable
    },

    emailsArray () {
      return this.param?.emails?.split(',').map(email => ({ email }))
    }
  },
  watch: {
    'param.did_id': function (newVal, oldVal) {
      this.set(this.param)
    },
    'param.emails': function (newVal, oldVal) {
      this.set(this.param)
    },
    'param.enabled': function (newVal, oldVal) {
      this.set(this.param)
    },
    emails: {
      handler (newVal, oldVal) {
        this.setEmails(this.emails)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      get: 'chat/SmsToEmails/get',
      set: 'chat/SmsToEmails/set',
      save: 'chat/SmsToEmails/save'
    }),

    async submit () {
      this.loadingSave = true
      await this.save()
      this.loadingSave = false
    },

    async reset () {
      this.loadingReset = true
      const didId = this.param.did_id
      this.param.did_id = null
      await this.get()
      this.loadingReset = false
      this.param.did_id = didId
      this.onDidChange(didId)
    },

    setEmails (emails) {
      this.param.emails = emails.map(obj => obj.email).join(',')
    },

    onDidChange (didId) {
      const existingRecord = this.smsToEmails?.find(smsToEmail => smsToEmail.did_id === didId)
      if (existingRecord) {
        this.param.enabled = existingRecord.enabled
        this.param.emails = existingRecord.emails
        this.param.did_id = didId
        this.emails = this.emailsArray
      } else {
        this.param.enabled = false
        this.param.emails = ''
        this.param.did_id = didId
        this.emails = this.emailsArray
      }
    },

    initLines () {
      if (this.emails.length === 0) {
        this.addLine()
      }
    },

    addLine () {
      this.emails = [...this.emails, { email: '' }]
    },

    deleteLine (linePosition) {
      this.emails = this.emails.filter((item, index) => index !== linePosition)
    },

    disableDelete (line, linePosition) {
      return this.emails.length === 1
    },

    phoneNumberIsRequired (value) {
      return !!value || this.$t('chat.smsToEmails.errors.phoneNumberRequired')
    },

    emailIsRequired (value) {
      return !!value || this.$t('chat.smsToEmails.errors.emailRequired')
    },

    emailIsValid (value) {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.$t('chat.smsToEmails.errors.emailInvalid')
    }
  }
}
</script>

<style>
</style>
